module.exports = __webpack_public_path__ + "img/plus.478bffd3.svg";